import { Chip } from "../Chip";
import Image from "../Image";
import React, { Fragment, useCallback, useState } from "react";
import { CSSProperties } from "styled-components";
import Box from "../Box";
import Button from "../buttons/Button";
import Card from "../Card";
import FlexBox from "../FlexBox";
import Grid from "../grid/Grid";
import Hidden from "../hidden/Hidden";
import Icon from "../icon/Icon";
import Modal from "../modal/Modal";
import NavLink from "../nav-link/NavLink";
import ProductIntro from "../products/ProductIntro";
import Rating from "../rating/Rating";
import { H5, Small, H2, H3, SemiSpan } from "../Typography";
import { StyledProductCard9 } from "./ProductCardStyle";
import { Link } from '@inertiajs/react'
import { CartItem } from "@reducer/cartReducer";
import { useAppContext } from "../../contexts/app/AppContext";
import Divider from "../Divider";
import CartService from "../../services/frontend/cart.service";
import useWindowSize from "../../hooks/useWindowSize";
import Fade from 'react-reveal/Fade';



export interface ProductCard9Props {
  id,
  className?: string;
  style?: CSSProperties;
  imgUrl?: string;
  title?: string;
  price?: number;
  off?: number;
  rating?: number;
  urlKey?: string
  desc?: text
  subcategories?: Array<{
    title: string;
    url: string;
  }>;
  [key: string]: unknown;
  // className?: string;
  // style?: CSSProperties;
  // imgUrl: string;
  // title: string;
  // price: number;
  // off: number;
  // rating?: number;
  // subcategories?: Array<{
  //   title: string;
  //   url: string;
  // }>;
}

const ProductCardList: React.memo<ProductCard9Props> = ({
  id,
  imgUrl,
  title,
  price,
  off,
  urlKey,
  subcategories,
  rating,
  variants,
  attributes,
  desc,
  sku,
  initialPrice,
  ...props
}) => {
  const [open, setOpen] = useState(false);
  const { state, dispatch } = useAppContext();
  const { auth, currency } = state
  const cartItem: CartItem = state.cart.cartList.find((item) => item.id === id);
  const cartService = new CartService()
  const screenWidth = useWindowSize()

  const toggleDialog = useCallback(() => {
    setOpen((open) => !open);
  }, []);

  const handleCartAmountChange = useCallback(
    (amount) => () => {
      /*dispatch(
        {
          'cart':
          {
            type: "CHANGE_CART_AMOUNT",
            payload: {
              name: title,
              qty: amount,
              price,
              imgUrl,
              id,
            },
          }
        }
      );*/

      let payload = {
        qty: amount,
        name: title,
        sku: sku,
        base_total_with_tax: price,
        base_price: price,
        total: price,
        price,
        imgUrl: imgUrl[0],
        id: id,
        product_id: id,
      }

      if (!cartItem) {
        cartService.add(dispatch, payload)

      } else {
        cartService.update(dispatch, payload)

      }

    },
    []
  );

  const attributeSizes: string[] = []

  //if (attributes) {
  attributes?.size?.map(sizes => {
    attributeSizes.push(sizes)
  })
  //}

  const uniqueSizes: string[] = attributeSizes.filter((size, index, array) => {
    return !array.slice(0, index).includes(size);
  })

  const checkSize = (size: any) => {
    for (let i = 0; i < variants.length; i++) {
      if (variants[i].size_label === size && variants[i].quantity > 0) {
        return true
      }
    }
    return false
  }

  const sizes = uniqueSizes.map((size: any) => {
    return {
      size: size,
      quantity: checkSize(size)
    }
  })

  return (
    <StyledProductCard9 overflow="hidden" width="100%" {...props}>
      <Fade>
        <Grid container spacing={1}>
          <Grid item lg={1.5} md={3} sm={11.5} xs={12} >
            <Box position="relative">
              {/* <Icon
              color="secondary"
              variant="small"
              className="quick-view"
              onClick={toggleDialog}
            >
              eye-alt
            </Icon> */}
              <Link href={urlKey}>
                <Image
                  src={imgUrl}
                  alt={title}
                  className="img-list-view"
                />
              </Link>
            </Box>
          </Grid>

          <Grid item md={8} sm={8} xs={12}>
            <FlexBox
              flexDirection="column"
              justifyContent="flex-start"
              pl={'1rem'}
            >
              <div className="categories">
                {subcategories?.map((item) => (
                  <NavLink className="link" href={item.url} key={item.title}>
                    {item.title}
                  </NavLink>
                ))}
              </div>

              <Link href={urlKey}>
                <H2 className='title-list-view' fontWeight="600" dangerouslySetInnerHTML={{ __html: title }}></H2>
              </Link>

              {/* <Rating
              value={rating || 0}
              outof={5}
              color="warn"
              onChange={(value) => {
                console.log(value, "from rating");
              }}
            /> */}
              {auth.isAuth &&
                <FlexBox position='relative'>
                  <SemiSpan className='price'>
                    {price + ' ' + currency.currencySymbol}
                  </SemiSpan>

                  {off > 0 && (
                    <SemiSpan ml={2} className='price initial-price'>
                      {initialPrice + ' ' + currency.currencySymbol}
                    </SemiSpan>
                  )}
                </FlexBox>
              }

              <FlexBox alignItems="flex-end" mt="10px" justifyContent='flex-start'>
                <H3 pr="0.5rem" fontWeight="400" color="white" className='diat'>
                  Διαθέσιμο σε :
                </H3>
                <FlexBox >
                  {sizes.map((element, i) => {
                    return (
                      <Small
                        className={`size ${element.quantity ? 'white-bg' : 'grey-bg'}`}
                        mr={1}
                        textAlign='center'
                        borderRadius={3}
                        color={element.quantity ? 'white' : 'grey'}
                        border={'solid 1px white'}
                        key={i}
                      >
                        {element.size}
                      </Small>)
                  })}
                </FlexBox>
              </FlexBox>

              <FlexBox mt={screenWidth > 580 ? "2rem" : '1rem'} mb="1rem" alignItems="center">
                <Small
                  fontWeight={100}
                  mr="0.5rem"
                  className='description-list-view'
                  dangerouslySetInnerHTML={{ __html: desc }}
                >
                </Small>
              </FlexBox>

            </FlexBox>
          </Grid>
        </Grid>

        <Divider width='90%' marginTop='1.4rem' marginLeft={0} />

        {/* <Modal open={open} onClose={toggleDialog}>
          <Card p="1rem" position="relative">
            <ProductIntro imgUrl={[imgUrl]} title={title} price={price} />
            <Box
              position="absolute"
              top="0.75rem"
              right="0.75rem"
              cursor="pointer"
            >
              <Icon
                className="close"
                color="primary"
                variant="small"
                onClick={toggleDialog}
              >
                close
              </Icon>
            </Box>
          </Card>
        </Modal> */}
      </Fade>
    </StyledProductCard9>
  );
};



export default ProductCardList;
